<template>
    <section class="pb-6 px-5" :class="{ 'has-background-grey': showGreyBackground }">
        <div class="container is-max-desktop padding-responsive">
            <div class="columns is-multiline">
                <!-- Mensaje sin oficinas -->
                <div class="column is-full" v-if="showWarningMessage">
                    <div class="card card-alert card-alert-warning">
                        <div class="columns is-mobile">
                            <div class="column is-narrow">
                                <i class="las la-search-location is-size-4 has-text-warning"></i>
                            </div>
                            <div class="column">
                                <div class="card-alert-text">
                                    <p>Por el momento, no tenemos una sucursal en esta comuna. Revisa las
                                        opciones de atención presencial disponibles.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="selectedComuna">
                    <div class="column is-full mt-4 mb-3">
                        <h3>Otras opciones de atención:</h3>
                    </div>

                    <!-- Oficina municipal más cercana -->
                    <div
                        v-for="office in nearestMunicipalOffice"
                        v-if="office"
                        :key="office.id"
                        class="column is-6-tablet is-4-widescreen">
                        <sucursal-card :office="office"></sucursal-card>
                    </div>

                    <!-- <div v-if="nearestMunicipalOffice" class="column is-6-tablet is-4-widescreen">
                        <div v-for="nearestMunicipalOffice in municipalOffices">
                            <sucursal-card :office="municipalOffices"></sucursal-card>
                        </div>
                    </div> -->

                    <!-- Cards fijas -->
                    <div class="column is-6-tablet is-4-widescreen">
                        <div class="card has-border-green-light is-height-auto">
                            <h4 class="mb-3"><strong>Centros Fundación de las Familias</strong></h4>
                            <p class="mb-3">Acércate a estos centros donde te acompañarán para hacer tus trámites en
                                línea.
                            </p>
                            <a href="https://www.google.com/maps/d/u/0/viewer?mid=1pj3L0JYNj_05Ir0dbOBE6JolVzwmYFXP&ll=-37.797673881670626%2C-71.29279065000001&z=4"
                                class="is-link-underline">Encuentra el centro más cercano.</a>
                        </div>
                    </div>

                    <div class="column is-6-tablet is-4-widescreen">
                        <div class="card has-border-green-light is-height-auto">
                            <h4 class="mb-3"><strong>Pago de pensiones y beneficios</strong></h4>
                            <p class="mb-3">Conoce los locales de pago de la Caja de Compensación Los Héroes y del
                                BancoEstado, en sus respectivos horarios de atención</p>
                            <a href="https://www.ips.gob.cl/redatencion/locales-de-pago"
                                class="is-link-underline">Revisa los locales de pago.</a>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>
<script>
import SucursalCard from './SucursalCard.vue'

export default {
    components: {
        SucursalCard,
    },
    props: ['hasOffices', 'filteredOfficesRegion', 'filteredOffices', 'selectedComuna', 'comunas'],
    computed: {
        municipalOffices() {
            if (this.hasOffices && this.filteredOffices.length) {
                return this.filteredOffices.filter(office => office.is_municipal);
            }
            return this.filteredOfficesRegion.filter(office => office.is_municipal);
        },
        showGreyBackground() {
            return this.hasOffices && !this.municipalOffices.length;
        },
        showWarningMessage() {
            return !this.hasOffices;
        },
        referenciaComuna() {
            return this.comunas.find(comuna => comuna.value === this.selectedComuna);
        },
        nearestMunicipalOffice() {
            if (!this.municipalOffices.length || !this.referenciaComuna) {
                return null;
            }

            const officesWithDist = this.municipalOffices
                .map(office => {
                    const distance = this.calculateDistance(
                        this.referenciaComuna.lat,
                        this.referenciaComuna.lng,
                        office.lat,
                        office.lng
                    );

                    return {
                        ...office,
                        distance: parseFloat(distance.toFixed(2))
                    };
                })
                .sort((a, b) => a.distance - b.distance);
                // console.log(officesWithDist);
                // console.log(officesWithDist[0]);
            return officesWithDist;
        }
    },
    methods: {
        calculateDistance(lat1, lon1, lat2, lon2) {
            const R = 6371;
            const toRadian = angle => (Math.PI / 180) * angle;

            const dLat = toRadian(lat2 - lat1);
            const dLon = toRadian(lon2 - lon1);

            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const distance = R * c;

            return distance;
        }
    }
}
</script>